import { combineReducers } from "redux";

import document from "../features/admin/internship/document/Slice";
import requirement from "../features/admin/internship/requirement/Slice";
import internships from "../features/admin/internship/internship/Slice";
import hotelregistration from "../features/admin/internship/hotelauth/Slice"

const internship = combineReducers({
  document: document,
  requirement: requirement,
  internships: internships,
  hotelregistration: hotelregistration,
});

export default internship;
